import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { viewerIcon, buttonTarget } from "../../services/viewers";

import BackButton from "./BackButton";

import ViewerStyle from '../../css/Viewer.module.css';

export default function MenuUniversoClaro(props) {
    const { viewersUniversoClaro, setActiveMenuButton, handleShowClaroUniverse, handleButtonClick, activeMenuButton, location, dataViewers } = props;
    useEffect(() => {
        if (viewersUniversoClaro.length > 0) {
            if (activeMenuButton === '') {
                const first = viewersUniversoClaro.find(viewer => viewer.population !== 'people') || viewersUniversoClaro[0];
                setActiveMenuButton(first.id)
                localStorage.setItem("selectedMenuButton", first.id)
            }

            // The month a route belongs to: a button is drawn for the Hogares
            // viewer of its pair, so a Personas viewer marks its counterpart's.
            const slug = (location.pathname).split('/')[2];
            const current = dataViewers.find(viewer => viewer.slug === slug);
            if (current) {
                const button = current.population === 'people'
                    ? dataViewers.find(viewer => viewer.id === current.counterpart) || current
                    : current;
                setActiveMenuButton(button.id)
                localStorage.setItem("selectedMenuButton", button.id)
            }
        }
    }, [viewersUniversoClaro, dataViewers, location.pathname, activeMenuButton, setActiveMenuButton]);

    const months = viewersUniversoClaro.filter(viewer => viewer.population === 'households').map((viewer, i) => {
        const target = buttonTarget(viewer, dataViewers);
        const index = dataViewers.indexOf(target);
        const isActive = activeMenuButton === viewer.id;
        return (
            <Link key={viewer.id}
                to={`/visor-rpd/${target.slug}`}
                title={viewer.label.replace(" Hogares", "")}
                className={`${ViewerStyle["btn-month"]}${isActive ? ` ${ViewerStyle["active"]}` : ''}`}
                onClick={() => handleButtonClick(viewer.id, index)}>
                <ion-icon name={viewerIcon(viewer)}></ion-icon>
                <span>{viewer.label.replace(" Hogares", "")}</span>
            </Link>
        );
    });

    return (
        <>
            <BackButton onClick={handleShowClaroUniverse} />
            {months}
        </>
    );
}